export default "__VITE_ASSET__ee2b9f97__"